import Vue from 'vue';
import * as types from './mutation-types';

export const setUser = async (context) => {
  const { data } = await Vue.axios('application.get-profile');
  context.commit(types.SET_USER, data);
};
